import Api from "./Api";

const endpoint = "/notenverwaltung/noten";
export default {
    get() {
        return Api.fetchData(endpoint);
    },
    getSV() {
        return Api.fetchData("/notenverwaltung/sv");
    },
    getNotentyp() {
        return Api.fetchData("/notenverwaltung" + "/notentyp");
    },
    getNotenart(id) {
        return Api.fetchData(endpoint + "/" + id + "/art");
    },
    getNotenartByTypId(id, typId) {
        return Api.fetchData(endpoint + "/" + id + "/art/" + typId);
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    putNotenart(id, data) {
        return Api.putData(endpoint + "/" + id + "/art", data);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
